module.exports = __webpack_public_path__ + "static/media/kk-918_suite.e89a9a3e.png";